import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { FcGoogle } from 'react-icons/fc';

type LoginScreenProps = {
  errorMessage?: string | null;
};

const LoginScreen = ({ errorMessage }: LoginScreenProps) => {
  const { loginWithGoogle } = useAuth();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleGoogleLogin = () => {
    if (isProcessing) {
      return;
    }
    setIsProcessing(true);
    loginWithGoogle();
  };

  const message = errorMessage;
  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-4 pt-0">
      <div className="w-full max-w-xs">
        <div className="text-center space-y-5">
          <div className='text-left'>
            <h1 className="text-xl font-bold m-0">Welcome to AutoFi</h1>
            <h1 className="text-sm font-normal m-0 text-muted-foreground">Your Personal Finance Assistant</h1>
          </div>
          <div className="space-y-5">
            <p className="text-sm text-muted-foreground text-left">
              Sign in with your invited Google account to continue.
            </p>

            {message && (
              <div className="rounded-2xl border border-error bg-error/10 px-4 py-3 text-sm text-error">
                {message}
              </div>
            )}

            <button
              type="button"
              onClick={handleGoogleLogin}
              disabled={isProcessing}
              aria-busy={isProcessing}
              className={`w-full py-2 rounded-2xl border border-border text-primary font-semibold flex items-center justify-center gap-2 transition-colors ${isProcessing ? 'cursor-not-allowed opacity-60' : 'hover:bg-primary/10'
                }`}
            >
              <FcGoogle size={18} />
              <span>{isProcessing ? 'Connecting...' : 'Continue with Google'}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
